const allDialogsData = {
    counter: 1,
    buttons: []
};

const AbstractDialog = function (settings, responsiveConstraints) {

    let dialogElement = null;

    let dialogSettings = {
        id: null,
        button: undefined,
        buttonIndex: null,
        event: undefined,
        minWidth: null,
        maxWidth: null,
        width: null,
        minHeight: null,
        maxHeight: null,
        height: null,
        centered: true,
        modal: true,
        closeOnClickOut: true,
        clickOutCheck: true,
        draggable: true,
        showBar: true,
        closeButton: true,
        barSettings: {
            title: 'Dialog' + allDialogsData.counter,
            options: [] // TODO: enable adding own options into dialog
        },
        //insertIntoParent: true,
        content: "",
        beforeClose: function (callback) {
            callback(true);
        },
        afterClose: function (callback) {
            callback(true);
        },
        //detectChanges: false,
        //changeFound: false,
        /*classes: {
            container: "",
            bar: "",
            title: "",
            close: "",
            body: "",
            content: ""
        }*/
    };

    let defaultConstraints = {
        width: null,
        minWidth: 300,
        maxWidth: function () {
            return $(window).width() - 20;
        },
        height: null,
        minHeight: 100,
        maxHeight: function () {

            let navbarHeight = 0;

            if (this.dialogElement) {

                let navbar = this.dialogElement.find('.navbar');

                if (isDefined(navbar)) {
                    navbarHeight = navbar.outerHeight(true);
                }

            }

            return $(window).height() - navbarHeight - 50;
        },
        centered: true,
        modal: true,
        draggable: true
    };

    let baseResponsiveConstraints = {
        mediaMaxWidth: {
            768: {
                width: null,
                minWidth: 200,
                maxWidth: function () {
                    return $(window).width() - 10;
                },
                height: null,
                minHeight: 100,
                maxHeight: function () {
                    return $(window).height() - 10;
                },
                centered: true,
                modal: true,
                draggable: true
            },
            480: {
                minWidth: null,
                maxWidth: null,
                minHeight: null,
                maxHeight: null,
                width: function () {
                    return $(window).width();
                },
                height: function () {
                    return $(window).height();
                },
                centered: true,
                modal: true,
                draggable: false
            }
        }
    };

    parseOptions(dialogSettings, settings);
    parseOptions(defaultConstraints, settings);
    parseOptions(baseResponsiveConstraints, responsiveConstraints);

    Object.defineProperties(this, {
        id: {
            get: function () {
                return dialogSettings.id;
            },
            set: function (id) {
                if (this.id === null) {
                    dialogSettings.id = id;
                } else {
                    console.error('ID of dialog can\'t be changed');
                }
            }
        },
        button: {
            get: function () {
                return dialogSettings.button;
            },
            set: function (btn) {
                if (isObject(btn)) {
                    dialogSettings.button = btn;
                }
            }
        },
        buttonIndex: {
            get: function () {
                return dialogSettings.buttonIndex;
            },
            set: function (index) {
                if (isNumeric(index)) {
                    dialogSettings.buttonIndex = index;
                }
            }
        },
        event: {
            get: function () {
                return dialogSettings.event;
            },
            set: function (event) {
                if (isObject(event)) {
                    dialogSettings.event = event;
                }
            }
        },
        minWidth: {
            get: function () {
                if (isFunction(dialogSettings.minWidth)) {
                    return dialogSettings.minWidth();
                } else {
                    return dialogSettings.minWidth;
                }
            },
            set: function (minWidth) {
                if (isNumeric(minWidth) || isFunction(minWidth)) {
                    defaultConstraints.minWidth = minWidth;
                }
            }
        },
        maxWidth: {
            get: function () {
                if (isFunction(dialogSettings.maxWidth)) {
                    return dialogSettings.maxWidth();
                } else {
                    return dialogSettings.maxWidth;
                }
            },
            set: function (maxWidth) {
                if (isNumeric(maxWidth) || isFunction(maxWidth)) {
                    defaultConstraints.maxWidth = maxWidth;
                }
            }
        },
        width: {
            get: function () {
                if (isFunction(dialogSettings.width)) {
                    return dialogSettings.width();
                } else {
                    return dialogSettings.width;
                }
            },
            set: function (width) {
                if (isNumeric(width) || isFunction(width)) {
                    defaultConstraints.width = width;
                }
            }
        },
        minHeight: {
            get: function () {
                if (isFunction(dialogSettings.minHeight)) {
                    return dialogSettings.minHeight();
                } else {
                    return dialogSettings.minHeight;
                }
            },
            set: function (minHeight) {
                if (isNumeric(minHeight) || isFunction(minHeight)) {
                    defaultConstraints.minHeight = minHeight;
                }
            }
        },
        maxHeight: {
            get: function () {
                if (isFunction(dialogSettings.maxHeight)) {
                    return dialogSettings.maxHeight();
                } else {
                    return dialogSettings.maxHeight;
                }
            },
            set: function (maxHeight) {
                if (isNumeric(maxHeight) || isFunction(maxHeight)) {
                    defaultConstraints.maxHeight = maxHeight;
                }
            }
        },
        height: {
            get: function () {
                if (isFunction(dialogSettings.height)) {
                    return dialogSettings.height();
                } else {
                    return dialogSettings.height;
                }
            },
            set: function (height) {
                if (isNumeric(height) || isFunction(height)) {
                    defaultConstraints.height = height;
                }
            }
        },
        centered: {
            get: function () {
                return dialogSettings.centered;
            },
            set: function (centered) {
                if (isBoolean(centered)) {
                    defaultConstraints.centered = centered;
                }
            }
        },
        modal: {
            get: function () {
                return dialogSettings.modal;
            },
            set: function (modal) {
                if (isBoolean(modal)) {
                    defaultConstraints.modal = modal;
                }
            }
        },
        closeOnClickOut: {
            get: function () {
                return dialogSettings.closeOnClickOut;
            },
            set: function (closeOnClickOut) {
                if (isBoolean(closeOnClickOut)) {
                    defaultConstraints.closeOnClickOut = closeOnClickOut;
                }
            }
        },
        ClickOutCheck: {
            get: function () {
                return dialogSettings.clickOutCheck;
            },
            set: function (clickOutCheck) {
                if (isBoolean(clickOutCheck)) {
                    defaultConstraints.clickOutCheck = clickOutCheck;
                }
            }
        },
        draggable: {
            get: function () {
                return dialogSettings.draggable;
            },
            set: function (draggable) {
                if (isBoolean(draggable)) {
                    defaultConstraints.draggable = draggable;
                }
            }
        },
        closeButton: {
            get: function () {
                return dialogSettings.closeButton;
            },
            set: function (closeButton) {
                if (isBoolean(closeButton)) {
                    defaultConstraints.closeButton = closeButton;
                }
            }
        },
        showBar: {
            get: function () {
                return dialogSettings.showBar;
            },
            set: function (showBar) {
                if (isBoolean(showBar)) {
                    dialogSettings.showBar = showBar;
                }
            }
        },
        barTitle: {
            get: function () {
                return dialogSettings.barSettings.title;
            },
            set: function (title) {
                dialogSettings.barSettings.title = title;
            }
        },
        /*insertIntoParent: {
            get: function () {
                return dialogSettings.insertIntoParent;
            },
            set: function (insertIntoParent) {
                if(isBoolean(insertIntoParent)) {
                    dialogSettings.insertIntoParent = insertIntoParent;
                }
            }
        },*/
        content: {
            get: function () {
                return dialogSettings.content;
            },
            set: function (content) {
                dialogSettings.content = content;
            }
        },
        beforeClose: {
            get: function () {
                return dialogSettings.beforeClose;
            },
            set: function (fn) {
                if (isFunction(fn)) {
                    dialogSettings.beforeClose = fn;
                }
            }
        },
        afterClose: {
            get: function () {
                return dialogSettings.afterClose;
            },
            set: function (fn) {
                if (isFunction(fn)) {
                    dialogSettings.afterClose = fn;
                }
            }
        },
        /*detectChanges: {
            get: function () {
                return dialogSettings.detectChanges;
            },
            set: function (detectChanges) {
                if(isBoolean(detectChanges)) {
                    dialogSettings.detectChanges = detectChanges;
                }
            }
        },*/
        defaultConstraints: {
            get: function () {
                return defaultConstraints;
            }
        },
        responsiveConstraints: {
            get: function () {
                return baseResponsiveConstraints;
            }
        },
        dialogElement: {
            get: function () {
                return dialogElement;
            },
            set: function (dialog) {
                if (dialog.attr("id") !== this.id) {
                    console.error("Dialog element is not associated with this object");
                }
                dialogElement = dialog;
            }
        }
    });

    this.setDialogConstraints = function () {

        let windowWidth = $(window).width();
        let responsiveConstraints = this.responsiveConstraints.mediaMaxWidth;
        let chosenConstraints = this.defaultConstraints;

        let keys = Object.keys(responsiveConstraints).reverse();
        for (let key of keys) {
            if (windowWidth <= key) {
                chosenConstraints = responsiveConstraints[key];
            }
        }

        keys = Object.keys(chosenConstraints);

        for (let key of keys) {
            dialogSettings[key] = chosenConstraints[key];
        }

    };

};

AbstractDialog.prototype.buttonIsUsed = function (button) {
    if (isObject(button)) {
        for (let btn of allDialogsData.buttons) {
            if (isObject(btn) && btn.is(button)) {
                return true;
            }
        }
        return false;
    }
};

AbstractDialog.prototype.isDialog = function (element) {
    return element.hasClass("dialog");
};

AbstractDialog.prototype.getContainer = function (elemInDialog) {
    if (isObject(elemInDialog)) {
        if (elemInDialog.hasClass("dialog")) {
            return elemInDialog;
        } else {
            return elemInDialog.closest(".dialog");
        }
    }
};

AbstractDialog.prototype.getParentDialog = function (dialog) {
    if (this.isDialog(dialog)) {
        return dialog.parent().closest(".dialog");
    } else {
        console.error("Element is not dialog");
    }
};

AbstractDialog.prototype.getBody = function (dialog) {
    if (this.isDialog(dialog)) {
        return dialog.find(".edit-content").first();
    } else {
        console.error("Element is not dialog");
    }
};

AbstractDialog.prototype.fixDialog = function (event) {

    let newPosX, newPosY;
    let windowWidth = $(window).width();
    let dialogWidth = this.dialogElement.outerWidth(true);

    if (this.centered) {
        this.dialogElement.centerToScreen();
    } else {
        if (isDefined(event)) {
            newPosY = event.pageY;
            newPosX = event.pageX;
        }
        if ((newPosX + dialogWidth) > windowWidth) {
            newPosX = windowWidth - (dialogWidth + 50);
        }
        this.dialogElement.css({
            left: newPosX,
            top: newPosY
        });
    }
};

AbstractDialog.prototype.positionDialog = function (event, callback) {

    let self = this;
    if (this.getBody(this.dialogElement).find("img").length) {
        let images = this.getBody(this.dialogElement).find("img");
        images.batchImageLoad({
            loadingCompleteCallback: function () {
                self.fixDialog(event);
                callback(true);
            }
        });
    } else {
        this.fixDialog(event);
        callback(true);
    }

};

AbstractDialog.prototype.setDialogWidthConstraints = function () {

    if (this.minWidth != null) {
        this.dialogElement.css('min-width', this.minWidth + "px");
    } else {
        this.dialogElement.css('min-width', '');
    }
    if (this.maxWidth != null) {
        this.dialogElement.css('max-width', this.maxWidth + "px");
    } else {
        this.dialogElement.css('max-width', '');
    }
    if (this.width != null) {
        this.dialogElement.css('width', this.width + "px");
    } else {
        this.dialogElement.css('width', '');
    }
};

AbstractDialog.prototype.setDialogHeightConstraints = function () {
    let body = this.getBody(this.dialogElement);

    let subtract = 0;
    if (this.showBar) {
        subtract = this.dialogElement.find(".navbar").outerHeight(true);
    }

    if (this.minHeight != null) {
        body.css('min-height', this.minHeight + "px");
    } else {
        body.css('min-height', '');
    }
    if (this.maxHeight != null) {
        body.css('max-height', (this.maxHeight - subtract) + "px");
    } else {
        body.css('max-height', '');
    }
    if (this.height != null) {
        body.css('height', (this.height - subtract) + "px");
    } else {
        body.css('height', '');
    }
};

AbstractDialog.prototype.insertDialogCoverLayer = function () {

    if (!$(document).find('#dialog-cover-' + this.id).length) {

        let cursor = 'default';
        if (this.closeOnClickOut) {
            cursor = 'pointer';
        }

        let layer = $('<div class="dialog-cover-layer" id="dialog-cover-' + this.id + '" style="cursor: ' + cursor + '"></div>');

        $("body").append(layer);

        layer.css({
            "width": $(window).width() + "px",
            "height": getDocHeight() + "px",
            "z-index": parseInt(this.dialogElement.css('z-index')) - 1
        });
    }

};

AbstractDialog.prototype.updateDialogCoverLayer = function () {
    let layer = $(document).find('#dialog-cover-' + this.id);
    layer.css({
        "width": $(window).width() + "px",
        "height": getDocHeight() + "px"
    });
};

AbstractDialog.prototype.deleteDialogCoverLayer = function () {
    $(document).find('#dialog-cover-' + this.id).remove();
};

AbstractDialog.prototype.updateInScope = function (event, callback) {

    this.updateDialogCoverLayer();
    this.setDialogConstraints();
    this.setDialogWidthConstraints();
    this.setDialogHeightConstraints();
    this.positionDialog(event, function (result) {
        if (result && isFunction(callback)) {
            callback(result);
        }
    });

};

AbstractDialog.prototype.close = function (callback) {

    let self = this;

    this.beforeClose(function (result) {
        if (result) {

            if (self.modal) {
                self.deleteDialogCoverLayer();
            }

            if (self.dialogElement.find("#resize-senzor" + self.id).length) {
                ResizeSensor.detach(self.dialogElement.find("#resize-senzor" + this.id));
            }

            if (self.buttonIndex != null) {
                allDialogsData.buttons.splice(self.buttonIndex, 1);
            }

            self.dialogElement.removeClass('opened');
            self.clickOutCheck = false;

            setTimeout(function () {
                self.afterClose(function (result) {
                    if (result) {
                        if (isFunction(callback)) {
                            callback(true);
                        }
                    }
                });
            }, 300);

        }
    });

};

AbstractDialog.prototype.open = function (callback) {

    this.dialogElement.css({
        'z-index': getLastLayerZIndex()
    });

    incrementLastLayerZIndex();

    if (this.modal) {
        this.insertDialogCoverLayer();
    }

    this.dialogElement.addClass('opened');
    this.clickOutCheck = true;

    let self = this;

    this.updateInScope(this.event, function (result) {
        if (result && isFunction(callback)) {
            callback(self.dialogElement);
        }
    });

};

AbstractDialog.prototype.create = function (callback) {

    if (this.dialogElement != null) {
        console.error("Dialog is already created");
        return false;
    }

    if (this.buttonIsUsed(this.button)) {
        console.error("This button has associated created dialog");
        return false;
    }

    this.setDialogConstraints();

    let self = this;
    let dialog;

    if (this.id == null) {

        let close = '';
        let navbar = '';

        this.id = 'dialog-' + allDialogsData.counter;

        if (this.closeButton) {
            close = '' +
                '<div class="navbar-group right-fixed">' +
                '<div class="navbar-item icon-link">' +
                '<a class="option close close-dialog">' +
                '<i class="fa fa-window-close fa-editor"></i>' +
                '</a>' +
                '</div>' +
                '</div>';
        }

        if (this.showBar) {
            navbar = '' +
                '<div class="navbar editor-theme header"><div class="navbar-body">' +
                '<div class="navbar-title">' + this.barTitle + '</div>' +
                close +
                '</div></div>';
        } else {
            navbar = '' +
                '<div class="navbar editor-theme header"><div class="navbar-body">' +
                close +
                '</div></div>';
        }

        dialog = $('' +
            '<div class="dialog" id="' + this.id + '">' +
            '<div class="resize-senzor" id="resize-senzor' + allDialogsData.counter + '">' +
            '<div class="editor">' +
            navbar +
            '<div class="edit-content">' +
            this.content +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>');

        $("body").append(dialog);

    } else {
        dialog = $(document).find('#' + this.id);
    }

    if (!dialog.parent().is($('body'))) {
        dialog.detach().appendTo($('body'));
    }

    dialog.data('instance', this);
    this.dialogElement = dialog;

    allDialogsData.buttons.push(this.button);
    this.buttonIndex = allDialogsData.buttons.length - 1;
    allDialogsData.counter++;

    this.dialogElement.off('click').on("click", " > .resize-senzor > .editor > .navbar .close-dialog", function (e) {
        e.preventDefault();
        self.close();
    });

    if (this.closeOnClickOut) {
        $(document).on("click", function (e) {
            if (self.clickOutCheck && self.dialogElement.isVisible()) {
                if (!self.isDialog(self.getContainer($(e.target)))) {
                    self.close();
                }
            }
        });
    }

    if (!this.modal && this.draggable) {
        let noDraggable = [];
        if (this.closeButton) {
            noDraggable.push(this.dialogElement.find(".close-dialog"));
        }
        noDraggable.push(this.dialogElement.find(".edit-content"));
        this.dialogElement.drags("", noDraggable);
    }

    this.updateInScope(this.event, function (result) {
        if (result && isFunction(callback)) {
            callback(dialog);
        }
    });

};

const BasicDialog = function (settings, responsiveConstraints) {
    AbstractDialog.call(this, settings, responsiveConstraints);
};

BasicDialog.prototype = Object.create(AbstractDialog.prototype);

BasicDialog.prototype.create = function (callback) {
    let self = this;
    AbstractDialog.prototype.create.call(this, function (dialog) {
        new ResizeSensor($("#resize-senzor" + self.id + ""), function (el) {
            if (isDefined(el)) {
                self.updateInScope();
            }
        });
        if (isObject(dialog) && isFunction(callback)) {
            callback(dialog);
        }
    });
};

const ConfirmDialog = function (ask, settings, responsiveConstraints) {

    if (!isDefined(settings.barSettings)) {
        settings.barSettings = {};
    }

    if (!isDefined(settings.barSettings.barTitle)) {
        settings.barSettings.barTitle = 'Hlášení programu';
    }

    AbstractDialog.call(this, settings, responsiveConstraints);

    let confirmDialogSettings = {
        ask: null
    };

    Object.defineProperty(this, 'ask', {
        get: function () {
            return confirmDialogSettings.ask;
        },
        set: function (ask) {
            confirmDialogSettings.ask = ask;
        }
    });

    this.ask = ask;
};

ConfirmDialog.prototype = Object.create(AbstractDialog.prototype);

ConfirmDialog.prototype.create = function (callback) {
    let self = this;

    self.modal = true;
    self.centered = true;
    self.content = '<div>' + this.ask + '<br />' + this.content + '<br />' +
        '<div class="fields-wrap ">' +
        '<a href="#" class="btn yes">Ano</a>' +
        '<a href="#" class="btn no">Ne</a></div>' +
        '</div>';

    AbstractDialog.prototype.create.call(this, function (dialog) {
        callback(dialog);
    });

};

ConfirmDialog.prototype.open = function (callback) {

    let self = this;

    AbstractDialog.prototype.open.call(this, function (dialog) {

        if (self.button != null) {

            let result = true;

            if (self.button.prop("tagName") === "INPUT" || self.button.prop("tagName") === "BUTTON") {
                if (self.button.closest("form").length) {
                    result = self.button.closest("form").serialize();
                }
            }

            self.event.preventDefault();

            dialog.find(".btn.yes").click(function (e) {
                e.preventDefault();
                if (e.handled !== true) {
                    self.close();
                    e.handled = true;
                    callback(result);
                }
            });
            dialog.find(".btn.no").click(function (e) {
                e.preventDefault();

                if (e.handled !== true) {
                    self.close();
                    e.handled = true;
                    callback(false);
                }
            });

        } else {

            dialog.find(".btn.yes").click(function (e) {
                e.preventDefault();
                if (e.handled !== true) {
                    self.close();
                    e.handled = true;
                    callback(true);
                }
            });
            dialog.find(".btn.no").click(function (e) {
                e.preventDefault();

                if (e.handled !== true) {
                    self.close();
                    e.handled = true;
                    callback(false);
                }
            });

        }
    });

};

const AlertDialog = function (message, settings, responsiveConstraints) {
    AbstractDialog.call(this, settings, responsiveConstraints);

    let alertDialogSettings = {
        ask: null
    };

    Object.defineProperty(this, 'message', {
        get: function () {
            return alertDialogSettings.message;
        },
        set: function (message) {
            alertDialogSettings.message = message;
        }
    });

    this.message = message;
};

AlertDialog.prototype = Object.create(AbstractDialog.prototype);

AlertDialog.prototype.create = function (callback) {
    let self = this;

    if (this.showBar) {
        self.barTitle = "Hlášení programu";
    }

    self.modal = true;
    self.centered = true;
    self.content = '<br /><div style="text-align: center;">' + self.message + '</div><br />';

    AbstractDialog.prototype.create.call(this, function (dialog) {
        if (dialog && isFunction(callback)) {
            callback(dialog);
        }
    });

};

$(window).resize(function () {
    $(document).find(".dialog").each(function () {
        let instance = $(this).data("instance");
        if (isDefined(instance)) {
            instance.updateInScope();
        }
    });
});

$(window).on("orientationchange", function () {
    $(document).find(".dialog").each(function () {
        let instance = $(this).data("instance");
        if (isDefined(instance)) {
            instance.updateInScope();
        }
    });
});

$(document).ready(function () {

    $(document).find(".dialog.auto-open").each(function () {
        let dialog = $(this);
        let autoCreatedDialog = new BasicDialog(dialog.data('params'));
        autoCreatedDialog.create(function () {
            autoCreatedDialog.open();
        });
    });

});